import { combineReducers } from 'redux';

import consultaMudancaCategoria from './consultaMudancaCategoria/reducer';
import gerarRenach from './gerarRenach/reducer';

export default combineReducers({
	consultaMudancaCategoria,
	gerarRenach,
});
